/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";

@Component({
   standalone: false,
   selector: "timezone-list",
   templateUrl: "./timezone-list.component.html"
})
export class TimezoneListComponent {
   @Input() timeZoneStatus;
   @Input() timeZoneRegion;
   @Output() selectedTimezone = new EventEmitter();
   public selectedValue;
   constructor() {}

   ngOnChanges(changes: SimpleChanges) {
      if (changes["timeZoneRegion"]?.currentValue) {
         this.selectedValue = changes["timeZoneRegion"].currentValue;
      }
   }

   public changeTimezone = (change) => {
      this.selectedValue = change.target.value;
      this.selectedTimezone.emit(change.target.value);
   };
}
